export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function currentEntryHref(): string {
  return `${window.location.pathname}${window.location.search}`;
}

export function readHistoryStateKey(state: unknown, key: string): unknown {
  return isRecord(state) ? state[key] : undefined;
}

// Same-URL replaceState that keeps every other key on the entry, Next's router state included.
export function mergeHistoryState(patch: Record<string, unknown>): void {
  const state = isRecord(window.history.state) ? window.history.state : {};
  window.history.replaceState({ ...state, ...patch }, '');
}
